export default "__VITE_ASSET__87_6dFcF__"